import { AfterViewInit, Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

export interface NotificationDialogModel {
  title: string;
  message: string;
  success: boolean;
}

@Component({
  templateUrl: './notification.dialog.component.html'
})

export class NotificationDialogComponent extends DialogComponent<NotificationDialogModel, string>
  implements AfterViewInit, NotificationDialogModel {

  title: string;
  message: string;
  success: boolean;

  ngAfterViewInit(): void {
    if (this.success) {
      setTimeout(() => this.close(), 5000);
    }
  }

  constructor(private ds: DialogService) {
    super(ds);
  }

  apply() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/notification/notification.dialog.component.ts